import { Injectable } from "@angular/core";
import { HttpService } from 'src/core/http/http.service';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/config/app-config.service';

@Injectable()
export class NewslettersService {
     
    constructor(private http: HttpService) {
    }
    
    public subscription(data: any): Observable<any> {
        let url = AppConfig.settings.authenticationApi + AppConfig.settings.ApiSegments.mailChimp;
        return this.http.post(url, data)
      }

      public unSubscription(data: any): Observable<any> {
        let url = AppConfig.settings.authenticationApi + AppConfig.settings.ApiSegments.mailChimp;
        return this.http.put(url, data)
      }
  


}